import React from 'react';

import { AVAILABLE_YEARS } from '../../pages/newResults/newResultsConstants';

export default function CompetitionFiltersToolbar({
	state,
	zones,
	championships,
	categories,
	onUpdateFilter,
}) {
	return (
		<div className="new-results-toolbar">
			<div className="new-results-field">
				<label htmlFor="nr-year">Saison</label>
				<select
					id="nr-year"
					value={state.year}
					onChange={(e) => onUpdateFilter('year', Number(e.target.value))}
				>
					{AVAILABLE_YEARS.map((y) => (
						<option key={y} value={y}>{y}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-zone">Zone</label>
				<select
					id="nr-zone"
					value={state.zone}
					onChange={(e) => onUpdateFilter('zone', e.target.value)}
				>
					<option value="">Choisir…</option>
					{zones.map((z) => (
						<option key={z} value={z}>{z}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-champ">Championnat</label>
				<select
					id="nr-champ"
					value={state.championship}
					disabled={!state.zone}
					onChange={(e) => onUpdateFilter('championship', e.target.value)}
				>
					<option value="">Choisir…</option>
					{championships.map((c) => (
						<option key={c} value={c}>{c}</option>
					))}
				</select>
			</div>
			<div className="new-results-field">
				<label htmlFor="nr-cat">Catégorie</label>
				<select
					id="nr-cat"
					value={state.category}
					disabled={!state.championship}
					onChange={(e) => onUpdateFilter('category', e.target.value)}
				>
					<option value="">Choisir…</option>
					{categories.map((c) => (
						<option key={c} value={c}>{c}</option>
					))}
				</select>
			</div>
		</div>
	);
}
